import { motion } from "framer-motion"
import { CheckCircle } from "lucide-react"

interface SuccessMessageProps {
  phone: string
}

export function SuccessMessage({ phone }: SuccessMessageProps) {
  return (
    <motion.div
      className="text-center py-12"
      initial={{ opacity: 0, scale: 0.9 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{ duration: 0.5 }}
    >
      <div className="w-20 h-20 bg-gradient-to-br from-green-500 to-green-600 rounded-full flex items-center justify-center mx-auto mb-6">
        <CheckCircle size={40} className="text-white" />
      </div>
      <h3 className="text-2xl font-bold text-foreground mb-4">Quote Submitted Successfully!</h3>
      <p className="text-muted-foreground mb-6 max-w-md mx-auto">
        Thank you for your interest! We'll review your requirements and send you a detailed quote within 2 hours.
      </p>
      <div className="bg-gradient-to-r from-blue-50 to-green-50 rounded-xl p-4 border border-blue-100">
        <p className="text-sm text-foreground">
          <strong>What's next?</strong> Our team will contact you at <strong>{phone}</strong> to discuss your move details.
        </p>
      </div>
    </motion.div>
  )
}
